var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedicalCaseNormal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 9.16659C2.5 7.32564 3.99238 5.83325 5.83333 5.83325H14.1667C16.0076 5.83325 17.5 7.32564 17.5 9.16659V14.1666C17.5 16.0075 16.0076 17.4999 14.1667 17.4999H5.83333C3.99238 17.4999 2.5 16.0075 2.5 14.1666V9.16659ZM5.83333 7.49992C4.91286 7.49992 4.16667 8.24611 4.16667 9.16659V14.1666C4.16667 15.0871 4.91286 15.8333 5.83333 15.8333H14.1667C15.0871 15.8333 15.8333 15.0871 15.8333 14.1666V9.16659C15.8333 8.24611 15.0871 7.49992 14.1667 7.49992H5.83333Z",
    fill: "#7799A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.16675C9.53976 9.16675 9.16667 9.53984 9.16667 10.0001V10.8334H8.33333C7.8731 10.8334 7.5 11.2065 7.5 11.6667C7.5 12.127 7.8731 12.5001 8.33333 12.5001H9.16667V13.3334C9.16667 13.7937 9.53976 14.1667 10 14.1667C10.4602 14.1667 10.8333 13.7937 10.8333 13.3334V12.5001H11.6667C12.1269 12.5001 12.5 12.127 12.5 11.6667C12.5 11.2065 12.1269 10.8334 11.6667 10.8334L10.8333 10.8334V10.0001C10.8333 9.53984 10.4602 9.16675 10 9.16675Z",
    fill: "#1C3D45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33331 4.16667C7.87308 4.16667 7.49998 4.53976 7.49998 5V5.83333H5.83331V5C5.83331 3.61929 6.9526 2.5 8.33331 2.5H11.6666C13.0474 2.5 14.1666 3.61929 14.1666 5V5.83333H12.5V5C12.5 4.53976 12.1269 4.16667 11.6666 4.16667H8.33331Z",
    fill: "#1C3D45"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalCaseNormal);
export default __webpack_public_path__ + "static/media/medical_case_normal.64c5e0dea09b68ceaba205bc668a9ab6.svg";
export { ForwardRef as ReactComponent };